"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartService = void 0;
const tslib_1 = require("tslib");
const request_1 = require("../core/request");
class CartService {
    /**
     * @param authorization
     * @param requestBody
     * @returns CartResponse Success
     * @throws ApiError
     */
    static createCart(authorization, requestBody) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield request_1.request({
                method: 'POST',
                path: `/cart/create`,
                headers: {
                    'authorization': authorization,
                },
                body: requestBody,
                errors: {
                    400: `Bad Request`,
                    404: `Not Found`,
                },
            });
            return result.body;
        });
    }
    /**
     * CreateCart
     * @param authorization
     * @param requestBody
     * @returns CustomerAuthResponse Success
     * @throws ApiError
     */
    static createForLoggedIn(requestBody) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield request_1.request({
                method: 'POST',
                path: `/cart/createforloggedin`,
                body: requestBody,
                errors: {
                    302: `Redirect`,
                    400: `Bad Request`,
                },
            });
            return result.body;
        });
    }
    /**
     * @param cartId
     * @param authorization
     * @param shouldValidate
     * @returns RetrieveCartResponse Success
     * @throws ApiError
     */
    static retrieveCart(cartId, authorization, shouldValidate) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let options = {
                method: 'GET',
                path: `/cart/${cartId}`,
                headers: {
                    'authorization': authorization,
                },
                errors: {
                    400: `Bad Request`,
                    404: `Not Found`,
                },
            };
            if (shouldValidate !== undefined) {
                const query = { shouldValidate };
                options = Object.assign(Object.assign({}, options), { query });
            }
            const result = yield request_1.request(options);
            return result.body;
        });
    }
    /**
     * UpdateCart
     * @param authorization
     * @param requestBody
     * @returns CartResponse Success
     * @throws ApiError
     */
    static updateCart(authorization, requestBody) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield request_1.request({
                method: 'POST',
                path: `/cart/update`,
                headers: {
                    'authorization': authorization,
                },
                body: requestBody,
                errors: {
                    400: `Bad Request`,
                    404: `Not Found`,
                },
            });
            return result.body;
        });
    }
    /**
     * DeleteCart
     * @param cartId
     * @param itemId Format - int32.
     * @returns CartIdResponse Success
     * @throws ApiError
     */
    static deleteCart(cartId, itemId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield request_1.request({
                method: 'DELETE',
                path: `/cart/${cartId}/items/${itemId}`,
                errors: {
                    400: `Bad Request`,
                    404: `Not Found`,
                },
            });
            return result.body;
        });
    }
    /**
     * ValidateCart
     * @param cartId
     * @param authorization
     * @returns CartIdResponse Success
     * @throws ApiError
     */
    static validateCart(cartId, authorization) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield request_1.request({
                method: 'POST',
                path: `/cart/validate/${cartId}`,
                headers: {
                    'authorization': authorization,
                },
                errors: {
                    400: `Bad Request`,
                    404: `Not Found`,
                },
            });
            return result.body;
        });
    }
    /**
     * @param guestCartId
     * @param authorization
     * @returns CartIdResponse Success
     * @throws ApiError
     */
    static mergeCart(guestCartId, authorization) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield request_1.request({
                method: 'POST',
                path: `/cart/merge/guestcart/${guestCartId}`,
                headers: {
                    'authorization': authorization,
                },
                errors: {
                    400: `Bad Request`,
                    404: `Not Found`,
                },
            });
            return result.body;
        });
    }
    /**
     * AddCoupons
     * @param cartId
     * @param coupons
     * @returns CartIdResponse Success
     * @throws ApiError
     */
    static addCoupons(cartId, coupons) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield request_1.request({
                method: 'POST',
                path: `/cart/${cartId}/coupons/${coupons}`,
                errors: {
                    400: `Bad Request`,
                    404: `Not Found`,
                },
            });
            return result.body;
        });
    }
}
exports.CartService = CartService;
//# sourceMappingURL=CartService.js.map